export default __webpack_public_path__ + "static/media/screen4.262bc03d.png";